import { movies } from '@/mocks/movies';
import SectionHeading from './SectionHeading';
import MovieCard from './MovieCard';

export default function NewRelease() {
  const newMovies = movies.filter((m) => m.isNewRelease);
  const calendar = [...newMovies].sort((a, b) => a.releaseDate.localeCompare(b.releaseDate));

  return (
    <section id="new-release" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          kicker="2024 New Releases"
          title="新片上映：2024 新片与即将就位的档期"
          desc="这一分区聚焦 2024 年新片与即将上映的作品，既有已经可以观看的，也有进入档期倒计时的。列表按上映日期由近及远排列，方便你安排观影顺序。"
        />

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-10">
          <div className="lg:col-span-2 grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5">
            {newMovies.map((movie) => (
              <MovieCard key={movie.id} movie={movie} />
            ))}
          </div>

          <aside className="rounded-lg bg-background-50 border border-background-200 p-5 md:p-6">
            <h3 className="flex items-center gap-2 text-base md:text-lg font-bold text-foreground-950">
              <i className="ri-calendar-schedule-line text-primary-600 text-xl" />
              上映日历
            </h3>
            <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">
              以下日期为整理展示用的档期参考，实际可看时间以各地排片为准。
            </p>

            <ol className="mt-5 space-y-4">
              {calendar.map((movie, index) => (
                <li key={movie.id} className="relative pl-6">
                  <span
                    className={`absolute left-0 top-1.5 w-2.5 h-2.5 rounded-full ${
                      index === 0 ? 'bg-primary-500' : 'bg-secondary-400'
                    }`}
                  />
                  {index !== calendar.length - 1 && (
                    <span className="absolute left-[4px] top-5 bottom-[-16px] w-px bg-background-300" />
                  )}
                  <div className="flex items-baseline justify-between gap-3">
                    <span className="text-sm font-semibold text-foreground-900">{movie.title}</span>
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{movie.releaseDate}</span>
                  </div>
                  <p className="mt-0.5 text-xs text-foreground-500">{movie.genres.slice(0, 2).join(' / ')}</p>
                </li>
              ))}
            </ol>

            <a
              href="#library"
              className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 cursor-pointer"
            >
              去片库筛选更多新片
              <i className="ri-arrow-right-line" />
            </a>
          </aside>
        </div>
      </div>
    </section>
  );
}